import { render, staticRenderFns } from "./tinymce.vue?vue&type=template&id=4b6fecb3&scoped=true"
import script from "./tinymce.vue?vue&type=script&lang=js"
export * from "./tinymce.vue?vue&type=script&lang=js"
import style0 from "./tinymce.vue?vue&type=style&index=0&id=4b6fecb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6fecb3",
  null
  
)

export default component.exports